export function registrationLink() {
    this.$router.push('registration');
}